import Vue from 'vue'
import Router from 'vue-router'
import login from '@/view/login'
import home from '@/view/home/index'
import orgnization from '@/view/orgnization'
import userManage from '@/view/userManage/list'
import rolePower from '@/view/rolePower'
import show from '@/view/show'
import userDetails from '@/view/userManage/details'
const baseUrl = "/authFront"
Vue.use(Router)

export default new Router({
  routes: [
    {
      path:`${baseUrl}/show`,
      redirect: `${baseUrl}/show`
    },
    {
      path: "/",
      redirect: `${baseUrl}/login`
    },
    {
      path: `${baseUrl}/login`,
      name: 'login',
      component: login
    },
    // home
    {
      path: `${baseUrl}/home`,
      name: 'home',
      component: home,
    },
    {
      path: `${baseUrl}/orgnization`,
      name: 'orgnization',
      component: orgnization
    },
    {
      path: `${baseUrl}/userManage`,
      name: 'userManage',
      component: userManage
    },
    {
      path: `${baseUrl}/rolePower`,
      name: 'rolePower',
      component: rolePower
    },
    {
      path: `${baseUrl}/userDetails/:userId/:userName`,
      name: 'userDetails',
      component: userDetails
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js